

import React from 'react';
import { connect } from 'react-redux';
import LoadingAnimation from '../../../Utils/loadingAnimation.js';
import GeneralUtils from '../../../Utils/generalUtils.js';
import { setPlanDetails, setCurrentPage } from '../../../General/Actions';
import AddonCartComponent from './ActivateAddonCartComponent';
import ServiceCartComponent from '../UpgradeOffer/UpgradeOfferCartComponent';
import { Button } from 'reactstrap';
import SliderModal from '../../../Utils/sliderModal.js';
import moment from 'moment';
import MyAccountComponent from '../MyAccountComponent';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import PathIcon from '../../../ImageAssets/pathIcon.png';
import Constants from '../../../Utils/constants.json';

class AddonsSummaryComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            termsAndConditionsLink:true,
            isTermsAndConditionsModalVisible:false,
            profileId:"NA",
            totalMonthlyCharges:0,
            discount:3.00,
            orderDetails: "",
            isPopupVisible : false,
            allServiceDetailsArray: [],
            allCurrentActiveServiceCharge: 0,
            carouselDetails : {
                superLargeDesktop: {
                    // the naming can be any, depends on you.
                    breakpoint: { max: 1285, min: 1000 },
                    items: 5
                  },
                  desktop: {
                    breakpoint: { max: 850, min: 1000 },
                    items: 5
                  },
                  mobile: {
                    breakpoint: { max: 850, min: 300 },
                    items: 3
                  }
                },
            isCartVisibleForMobile: false,
            inCompatibleArr: [],
            allExistingAddonIds: [],
            addSubscriptionType: this.props.registerDetails.generalResponse.type
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        window.addEventListener('scroll', this.handleScroll);
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        if(this.state.addSubscriptionType === "changePlan"){
            this.initialisePlanComparison();
        }
        this.props.setPlanDetails("isSummaryReached", true);
        var orderResponse = "NA"
        try {
            if (this.props.planDetails.changePlanResponse.dataset.param[0]) {
                orderResponse = this.props.planDetails.changePlanResponse.dataset.param[0].value;
            }
        } catch (err) {
            orderResponse = "NA"
        }
        this.setState({ orderDetails: orderResponse })
      
        if (this.props.registerDetails.services.packageName) {
            this.setState({
                packageName: this.props.registerDetails.services.packageName
            });
        } else {
            this.setState({ packageName: "NA" });
        }
        if (this.props.registerDetails.services.packageAmount) {
            this.setState({
                packageAmount: this.props.registerDetails.services.packageAmount
            });
        } else {
            this.setState({ packageAmount: "0" });
        }
        if (this.props.registerDetails.services.discount) {
            this.setState({
                discount: this.props.registerDetails.services.discount
            });
        } else {
            this.setState({ discount: "0" });
        }

        if (this.props.registerDetails.services.packageDescription) {
            this.setState({
                packageDescription: this.props.registerDetails.services.packageDescription
            });
        } else {
            this.setState({ packageDescription: "NA" });
        }
      

       var packageWithDiscount = 0
        var packageWithDiscount_sup = 0
         var discountPrice = GeneralUtils.formatNumberToStandardForm((parseFloat(this.props.registerDetails.services.packageAmount) - parseFloat(this.props.registerDetails.services.discount)))
         discountPrice = discountPrice.split(".");
         packageWithDiscount = discountPrice[0]
         if(discountPrice.length > 1){
           packageWithDiscount_sup = discountPrice[1];
         } else{
           packageWithDiscount_sup = "00"
         }
        this.setState({"packageWithDiscount":packageWithDiscount});
        this.setState({"packageWithDiscount_sup" : packageWithDiscount_sup})
       this.calculateTotalCharge();
       this.getAllServiceDetailsFromBilling();
       setTimeout(() => {
        this.setState({ isPopupVisible: false });
    }, 6000);
    }

    initialisePlanComparison(){
        var compatibleArr = [];
        var inCompatibleArr = [];
        var allExistingAddonIds = []
        for(var a = 0; a < this.props.registerDetails.generalResponse.planComparisonData.currentAddonDetails.length; a++){
            var currentObj = this.props.registerDetails.generalResponse.planComparisonData.currentAddonDetails[a]
            if(currentObj.retainable === "true"){
                for(var b=0; b< this.props.registerDetails.generalResponse.planComparisonData.oldCartDetails.length; b++){
                    var oldObj = this.props.registerDetails.generalResponse.planComparisonData.oldCartDetails[b]
                    if(oldObj.planId === currentObj.planId){
                        var tempCompatible = {
                            "subscription_id": oldObj.subscriptionId,
                            "plan_id": oldObj.planId,
                            "plan_name": oldObj.planName
                        }
                        compatibleArr.push(tempCompatible)
                        allExistingAddonIds.push(currentObj.planId)
                    }
                }
            } else if (currentObj.retainable === "false"){
                var tempIncompatible = {
                    "subscription_id": currentObj.subscriptionId,
                    "plan_id": currentObj.planId,
                    "plan_name": currentObj.planName
                }
                inCompatibleArr.push(tempIncompatible)
            }
        }
        for(var j=0; j< this.props.registerDetails.generalResponse.planComparisonData.oldCartDetailsDevices.length; j++){
            var oldObj = this.props.registerDetails.generalResponse.planComparisonData.oldCartDetailsDevices[j]
                var tempCompatible = {
                    "subscription_id": oldObj.subscriptionId,
                    "plan_id": oldObj.planId,
                    "plan_name": oldObj.planName
                }
                compatibleArr.push(tempCompatible)
                allExistingAddonIds.push(oldObj.planId)
        }
        this.setState({
            compatibleArr: compatibleArr,
            inCompatibleArr: inCompatibleArr,
            allExistingAddonIds: allExistingAddonIds
        })
    }
    
    getAllServiceDetailsFromBilling(){
        var allServiceDetailsArray = []
        try{
            allServiceDetailsArray = this.props.registerDetails.currentPlanDetails.allServiceDetailsArray;
        } catch(err){

        }
        for(var i=0; i<allServiceDetailsArray.length; i++){
            if(this.props.registerDetails.givenAddress.serviceId === allServiceDetailsArray[i].serviceId){
                this.tabClicked(this.props.registerDetails.givenAddress.serviceId)
            }
        }
        
        this.setState({ 
            allServiceDetailsArray: allServiceDetailsArray,
            allCurrentActiveServiceCharge: this.props.registerDetails.currentPlanDetails.allCurrentActiveServiceCharge,
            isLoading: false,
            isPopupVisible : true
         });    
    }

    populateAllServiceDetails(item,receivedServiceId) {
        var isCurrentService = false;
        if(receivedServiceId === this.props.registerDetails.givenAddress.serviceId && this.props.registerDetails.generalResponse.type === "changePlan"){
            var currentService = this.props.registerDetails.offers
            isCurrentService = true;
            var isRecurring = true;
            var packageAmount = 0;
            var packageAmount_sup = 0;
            var Price = GeneralUtils.formatNumberToStandardForm(currentService.basePriceWithDiscount)
            Price = Price.split(".");
            packageAmount = Price[0]
                if (Price.length > 1) {
                    packageAmount_sup = Price[1];
                } else {
                    packageAmount_sup = "00"
                }
            var activePlanName = currentService.name;
            var activePlanAmount = packageAmount;
            var activePlanDecimal = packageAmount_sup;
            var discountArr = currentService.discountArray;
            var taxArr = currentService.taxArray;
            var offerAmount = currentService.offerAmount
        } else {
            var activePlanName = item.activePlanName;
            var activePlanAmount = item.activePlanAmount;
            var activePlanDecimal = item.activePlanDecimal;
            var discountAmount = item.discountAmount;
            var discountArr = [];
            var taxArr = [];
            var offerAmount = activePlanAmount + activePlanDecimal
            var isRecurring = false;
        }
        return (
            <div className="col-md-12 m-0 pt-4 pb-3">
                <div className="col-md-12 p-0" style={{ fontSize: 14, fontWeight: 600 }}>Offer{isCurrentService?<span style={{color:'#F78521',fontSize:12}}> (Upgraded)</span> : null}</div>
                            <div className="py-3" style={{ border: '1px solid rgb(179, 179, 179)', borderRadius: 4, boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2px 4px 0px' }}>
                                <div className="col-md-12 p-0 m-0">
                                    <div className="col-md-12 m-0 d-flex justify-content-between">
                                        <div style={{ color: '#231F20', fontSize: 18, fontWeight: 500 }}>{activePlanName}</div>
                                        <div className="d-flex">
                                            {/* {parseFloat(item.discount) > 0 ?
                                                <div className="mt-1" style={{ textDecoration: 'line-through', fontSize: 12, color: '#B6B6B6' }}>{Constants.dollarSign}{item.totalBasePrice}</div>
                                                :
                                                null
                                            } */}
                                             { parseFloat(activePlanAmount) > 0 ?
                                            <div className="ml-2 d-flex justify-content-end" style={{ color: '#231F20' }}>
                                                <span style={{ fontSize: 12 }}>{Constants.dollarSign}</span><span style={{ fontSize: 18, lineHeight: '20px' }}>{activePlanAmount}</span><span style={{ fontSize: 12 }}>{activePlanDecimal}/mo.</span>
                                            </div>
                                            : null }
                                        </div>
                                    </div>
                                    <div className="col-md-12 m-0 d-flex justify-content-between">
                                        <div style={{ color: '#58595B', fontSize: 12 }}>{item.activePlanDesc}</div>
                                        {discountArr.length > 0 ?
                                            <div>
                                                <div style={{ fontSize: 10, color: '#231F20' }}>(Base Price - Discount)</div>
                                            </div>
                                            :
                                            null
                                        }
                                    </div>
                                    <div className="col-md-12 m-0 d-flex justify-content-end flex-column align-items-end">
                            <div className="d-flex">
                                <div style={{ fontSize: 12, color: '#58595b' }}>Base Price</div>
                                <div className="ml-4" style={{ color: '#58595b', fontSize: 12, fontWeight: 500 }}>{Constants.dollarSign}{GeneralUtils.formatNumberToStandardForm(offerAmount)}</div>
                            </div>
                        </div>
                        <div className="col-md-12 m-0 d-flex justify-content-end flex-column align-items-end">
                            {discountArr.map((item, key) => {
                                return (
                                    <div className="d-flex" key={key}>
                                        <div style={{ fontSize: 12, color: '#58595b' }}>{item.discountName}</div>
                                        <div className="ml-4" style={{ color: '#58595b', fontSize: 12, fontWeight: 500 }}>-{Constants.dollarSign}{GeneralUtils.formatNumberToStandardForm(item.discountPrice)}</div>
                                    </div>
                                )
                            })
                            }
                        </div>
                        <div className="col-md-12 m-0 d-flex justify-content-end flex-column align-items-end">
                            {taxArr.map((item, key) => {
                                return (
                                    <div className="d-flex" key={key}>
                                        <div style={{ fontSize: 12, color: '#58595b' }}>{item.taxName}</div>
                                        <div className="ml-4" style={{ color: '#58595b', fontSize: 12, fontWeight: 500 }}>+{Constants.dollarSign}{GeneralUtils.formatNumberToStandardForm(item.taxPrice)}</div>
                                    </div>
                                )
                            })
                            }
                        </div>
                                </div>
                            </div>
            </div>
        )
    }

    populateExistingDevicesComponent(receviedDeviceArray) {
        var isDevicesAvailable = false;
        const populateEquipmentCharges = receviedDeviceArray.map((item, key) => {
            isDevicesAvailable = true;
            var packageAmount = 0
            var packageAmount_sup = 0
            var price = GeneralUtils.formatNumberToStandardForm(item.devicePrice)
            price = price.split(".");
            packageAmount = price[0]
            if (price.length > 1) {
                packageAmount_sup = price[1];
            } else {
                packageAmount_sup = "00"
            }
               return (
                    <div key={key} className="py-3 mb-2" style={{ border: '1px solid rgb(179, 179, 179)', borderRadius: 4, boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2px 4px 0px' }}>
                        <div className="col-md-12 p-0 m-0">
                            <div className="col-md-12 m-0 d-flex justify-content-between">
                                <div style={{ color: '#231F20', fontSize: 16, fontWeight: 500 }}>{item.deviceName} {item.isIncluded ? <span style={{ fontSize: 12, color: '#231F20' }}>(Included)</span> : null}

                                </div>
                                <div className="d-flex">
                                    {item.isIncluded ?
                                        null
                                        :
                                        <div className="ml-2 d-flex justify-content-end" style={{ color: '#231F20' }}>
                                            <span style={{ fontSize: 12 }}>{Constants.dollarSign}</span><span style={{ lineHeight: '22px', fontSize: 18 }}>{packageAmount}</span><span style={{ fontSize: 12 }} >{packageAmount_sup}/mo.</span>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="col-md-12 m-0 d-flex justify-content-between">
                                <div style={{ color: '#58595B', fontSize: 12 }}>Device Description : {item.deviceDesc}</div>
                                {item.isIncluded ? null : <div style={{ fontSize: 10, color: '#231F20' }}>(Fee)</div>}
                            </div>
                        </div>
                    </div>
                )
        });

        if (isDevicesAvailable) {
            return (<div className="col-md-12 pb-3 "><div className="col-md-12 p-0" style={{ fontSize: 14, fontWeight: 600 }}>Device(s)</div><div>{populateEquipmentCharges}</div></div>);
        }
    }

    populateExistingAddonsComponent(receivedAddonArray,receivedItem) {
        var isAddonsAvailable = false;
        const populateAddonCharges = receivedAddonArray.map((item, key) => {
            var isNonCompatible = true
            for(var k=0; k< this.state.inCompatibleArr.length; k++){
                if(this.state.inCompatibleArr[k].plan_id === item.planId){
                    isNonCompatible = false
                }
            }
            isAddonsAvailable = true;
            var packageAmount = 0
            var packageAmount_sup = 0
            var price = GeneralUtils.formatNumberToStandardForm(item.addonPrice)
            price = price.split(".");
            packageAmount = price[0]
            if (price.length > 1) {
                packageAmount_sup = price[1];
            } else {
                packageAmount_sup = "00"
            }
         if(isNonCompatible != false){
            return (
                <div key={key} className="py-3 mb-2" style={{ border: '1px solid rgb(179, 179, 179)', borderRadius: 4, boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2px 4px 0px' }}>
                    <div className="col-md-12 p-0 m-0">
                        <div className="col-md-12 m-0 d-flex justify-content-between">
                            <div style={{ color: '#231F20', fontSize: 16, fontWeight: 500 }}>{item.addonName} {item.isIncluded ? <span style={{ fontSize: 12, color: '#231F20' }}>(Included)</span> : null}

                            </div>
                            <div className="d-flex">
                                {item.isIncluded || parseFloat(packageAmount) <= 0 ?
                                    null
                                    :
                                    <div className="ml-2 d-flex justify-content-end" style={{ color: '#231F20' }}>
                                        <span style={{ fontSize: 12 }}>{Constants.dollarSign}</span><span style={{ fontSize: 18, lineHeight: '20px' }}>{packageAmount}</span><span style={{ fontSize: 12 }}>{packageAmount_sup}/mo.</span>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="col-md-12 m-0 d-flex justify-content-between">
                            <div style={{ color: '#58595b', fontSize: 12 }}>Add-on Description : {item.addonDesc}</div>
                            {item.isIncluded || parseFloat(packageAmount) <= 0 ? null : <div style={{ fontSize: 10, color: '#231F20' }}>(Base Price)</div>}
                        </div>
                    </div>
                </div>
            )
         }
        });
        if (isAddonsAvailable) {
            return (<div>{populateAddonCharges}</div>);
        }
    }

    calculateTotalCharge() {
        let sum = 0;

        for (var i = 0; i < this.props.registerDetails.customize.addons.length; i++) {
            sum = sum + (parseFloat(this.props.registerDetails.customize.addons[i].addonPriceWithDiscount || 0) * this.props.registerDetails.customize.addons[i].count)
        }

        if(this.state.addSubscriptionType === "changePlan" ){
        if(this.props.cache.currentPlanDetails.isContractExpired == false){
            sum = sum + parseFloat(this.props.registerDetails.offers.basePriceWithDiscount) + parseFloat(this.props.registerDetails.contractDetails.price)
        } else {
            sum = sum + this.props.registerDetails.offers.basePriceWithDiscount
        }
    }

        this.state.totalMonthlyCharges = sum;
        this.setState({ dummy: "dummy" });
    }
    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    handleInputValueChange(name,event){
        const value = event.target.checked;
        this.state[name]=value;
        // if(this.state.termsAndConditionsLink){
        //     this.setState({isTermsAndConditionsModalVisible:true})
        // }
        // else{
        //     this.setState({isTermsAndConditionsModalVisible:false})
        // }
    };

    closeButtonButtonClicked() {
        this.setState({redirectToMyAccount: true})
    }

    tabClicked(type) {
        for (var i = 0; i < this.props.registerDetails.givenAddress.allServiceId.length; i++) {
            if (this.props.registerDetails.givenAddress.allServiceId[i].serviceId === type) {
                this.props.registerDetails.givenAddress.allServiceId[i]["status"] = true
            } else {
                this.props.registerDetails.givenAddress.allServiceId[i]["status"] = false
            }
            this.setState({ tab: type, tabNew: "" })
        }
        for (var j = 0; j < this.props.registerDetails.services.length; j++) {
            this.props.registerDetails.services[j]["status"] = false
        }
    }

    populateAddonDetailsComponent(receivedItem,receivedAddonArr) {
        var isEquipmentsEmpty = false;
        const populateAddonCharges = this.props.registerDetails.customize.addons.map((item, key) => {
            var isExistingAddon = false
            if(this.state.allExistingAddonIds.includes(item.id)){
                isExistingAddon = true
            }
          
            var packageAmount = 0
            var packageAmount_sup = 0
            var price = GeneralUtils.formatNumberToStandardForm(item.count * item.addonPriceWithDiscount)
            price = price.split(".");
            packageAmount = price[0]
            if (price.length > 1) {
                packageAmount_sup = price[1];
            } else {
                packageAmount_sup = "00"
            }
            var discountArr = item.discountArray;
            var taxArr = item.taxArray;
            var offerAmount = item.offerAmount;
            if(receivedItem.serviceId === this.props.registerDetails.givenAddress.serviceId && isExistingAddon == false){
                isEquipmentsEmpty = true;
                return (
                    <div key={key} className="py-3 mb-2" style={{ border: '1px solid rgb(179, 179, 179)', borderRadius: 4, boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2px 4px 0px' }}>
                    <div className="col-md-12 p-0 m-0">
                        <div className="col-md-12 m-0 d-flex justify-content-between">
                            <div style={{ color: '#231F20', fontSize: 16, fontWeight: 500 }}>{item.name} <span style={{color:'#F78521',fontSize:12}}> (New Add-on)</span>{item.isIncluded ? <span style={{ fontSize: 12, color: '#231F20' }}>(Included)</span> : null}

                            </div>
                            <div className="d-flex">
                                {item.isIncluded ?
                                    null
                                    :
                                    <div className="ml-2 d-flex justify-content-end" style={{ color: '#231F20' }}>
                                        <span style={{ fontSize: 12 }}>{Constants.dollarSign}</span><span style={{ fontSize: 18, lineHeight: '20px' }}>{packageAmount}</span><span style={{ fontSize: 12 }}>{packageAmount_sup}/mo.</span>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="col-md-12 m-0 d-flex justify-content-between">
                                <div style={{ color: '#58595b', fontSize: 12 }}>Add-on Description : {item.description}</div>
                                {item.isIncluded ? null
                                : 
                                discountArr.length > 0 ?
                                <div style={{ fontSize: 10, color: '#231F20' }}>(Base Price - Discount)</div>
                                :
                                <div style={{ fontSize: 10, color: '#231F20' }}>(Base Price)</div>
                                }
                            </div>
                    </div>
                    <div className="col-md-12 m-0 d-flex justify-content-end flex-column align-items-end">        
                            <div className="d-flex" key={key}>
                                <div style={{ fontSize: 12, color: '#58595b' }}>Base Price</div>
                                <div className="ml-4" style={{ color: '#58595b', fontSize: 12, fontWeight: 500 }}>{Constants.dollarSign}{GeneralUtils.formatNumberToStandardForm(parseFloat(offerAmount))}</div>
                            </div>
                        </div>
                        <div className="col-md-12 m-0 d-flex justify-content-end flex-column align-items-end">        
                            {discountArr.map((itemArr, key) => {
                                return (
                                    <div className="d-flex" key={key}>
                                        <div style={{ fontSize: 12, color: '#58595b' }}>{itemArr.discountName}</div>
                                        <div className="ml-4" style={{ color: '#58595b', fontSize: 12, fontWeight: 500 }}>-{Constants.dollarSign}{GeneralUtils.formatNumberToStandardForm(parseFloat(itemArr.discountPrice * item.count))}</div>
                                    </div>
                                )
                            })
                            }
                        </div>
                        <div className="col-md-12 m-0 d-flex justify-content-end flex-column align-items-end">        
                            {taxArr.map((itemArr, key) => {
                                return (
                                    <div className="d-flex" key={key}>
                                        <div style={{ fontSize: 12, color: '#58595b' }}>{itemArr.taxName}</div>
                                        <div className="ml-4" style={{ color: '#58595b', fontSize: 12, fontWeight: 500 }}>+{Constants.dollarSign}{GeneralUtils.formatNumberToStandardForm(parseFloat(itemArr.taxPrice))}</div>
                                    </div>
                                )
                            })
                            }
                        </div>
                    </div>
                )
            }
        });
        if (isEquipmentsEmpty) {
            return (<div className='pt-4'>{populateAddonCharges}</div>);
        } 

    }

    populateCustomerSummary() {
        return (
            <div className="col-md-12 m-0 p-0 customerSummaryBox">
                <div className="col-md-12 m-0 summaryBoxHeading">{this.props.locales.customerSummaryHeadingInAddSubscriptionSummary}</div>
                <div className="col-md-12 m-0 p-0 py-2">
                    <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center pb-2">
                        <div className="col-3 summaryBoxLabel">{this.props.locales.nameLabelInCustomerSummaryAddSubscription}</div>
        
                        <div className="col-9 summaryBoxData" style={{wordBreak: 'break-word'}}>: &nbsp;{this.props.registerDetails.confirmation.firstName} {this.props.registerDetails.confirmation.lastName}</div>
                    </div>
                    <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center pb-2">
                        <div className="col-3 summaryBoxLabel">{this.props.locales.contactNumLabelInCustomerSummaryAddSubscription}</div>
                       
                        <div className="col-9 summaryBoxData">: &nbsp;{this.props.registerDetails.confirmation.contactNumber|| "NA"}</div>
                    </div>
                    <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center pb-2">
                        <div className="col-3 summaryBoxLabel">{this.props.locales.emailLabelInCustomerSummaryAddSubscription}</div>
                       
                        <div className="col-9 summaryBoxData" title={this.props.registerDetails.confirmation.contactEmailAddress} style={{wordBreak: 'break-word'}}>: &nbsp;{this.props.registerDetails.confirmation.contactEmailAddress|| "NA"}</div>
                    </div>
                    <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center pb-2">
                        <div className="col-3 summaryBoxLabel">{this.props.locales.accountNumLabelInCustomerSummaryAddSubscription}</div>
                       
                        <div className="col-9 summaryBoxData">: &nbsp;{this.props.registerDetails.confirmation.accountId}</div>
                    </div>
                    <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center pb-2">
                        <div className="col-3 summaryBoxLabel">{this.props.locales.customerNumLabelInCustomerSummaryAddSubscription}</div>
                       
                        <div className="col-9 summaryBoxData">: &nbsp;{this.props.registerDetails.confirmation.profileId}</div>
                    </div>
                    <div className="col-12 m-0 p-0 d-flex justify-content-between align-items-center pb-2">
                        <div className="col-3 summaryBoxLabel">{this.props.locales.customerAddressLabelInCustomerSummaryAddSubscription}</div>
                       
                        <div className="col-9 summaryBoxData">: &nbsp;{this.props.registerDetails.givenAddress.AddressLine1}, {this.props.registerDetails.givenAddress.city}, {this.props.registerDetails.givenAddress.state}, {this.props.registerDetails.givenAddress.zip}</div>
                    </div>
                </div>
            </div>
        )
    }

    arrowButtonClicked(type){
        this.setState({isCartVisibleForMobile:type})
    }

    render() {
        if (this.state.redirectToMyAccount) {
            if(this.state.addSubscriptionType === "addFnFAddon"){
                return (
                    <MyAccountComponent feature="addFnFAddon" />
                )
            } else {
                return (
                    <MyAccountComponent feature="addAddon" />
                )
            }
        }
      
        return (
            <div>
                 {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : this.componentContent()}
            </div>
        );
    }

    componentContent() {
        return (
            <div id="changePlanConfirmationMainContainer"className="mt-4">
            {this.state.isPopupVisible ?
                <div className={this.state.isPopupVisible ?"col-12 animated fadeIn row popupFoSuccess" : "col-12 animated fadeOut row popupFoSuccess" }>
                    { this.state.addSubscriptionType === "addAddon" ||  this.state.addSubscriptionType === "addFnFAddon" ?
                    "Your Add-on(s) has been updated successfully"
                    : 
                    "Your Offer has been updated successfully"
                    }
                </div>
            : null } 
                  {this.state.isCartVisibleForMobile == false ?
                <div style={{width:'92%'}} className="ml-auto">
                <div className="col-md-12 row m-0 mt-3 p-0">
                    <div className="col-md-6 mt-sm-0 mt-5">
                        <div className="col-md-12 p-0"><div className="col-md-12 pb-2 p-0" style={{ color: '#33495F', fontSize: 32, fontWeight: 300 }}>Order Summary</div></div>
                        <div className="col-md-12 mb-2 p-0">
                            <div className="col-md-12 p-0">
                                <div className="col-md-12 d-flex p-0" style={{height:24}}>
                                    <div className="simpleLabel" style={{ color: '#33495F', fontSize: 16 }}>Order Id :</div>
                                    <div className="simpleLabel ml-3" style={{ fontWeight: 500 }}>{this.state.orderDetails}</div>
                                </div>
                                <div className="col-md-12 d-flex p-0">
                                    <div className="simpleLabel" style={{ color: '#33495F', fontSize: 16 }}>Order Date :</div>
                                    <div className="simpleLabel ml-3" style={{ fontWeight: 500 }}>{moment().format("MM/DD/YYYY")}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
              
                <div className="col-md-12 p-0" style={{marginBottom:75}}>
                <div className="col-md-12 row p-0 m-0">
                <div className="col-md-8 p-0 pb-4 pr-sm-5 pr-4"  id="orderSummaryPart">
                        <div className="col-md-12 p-0 m-0">
                            <div className="col-md-12 p-0 m-0">
                                {this.populateCustomerSummary()}
                            </div>
                        </div>
                        <div className="col-md-12 my-4 py-3" style={{backgroundColor:'#404042',borderRadius:4,color:'#ffffff',fontSize:14}}>
                            Service Address : <span style={{fontWeight:500}}>{this.props.registerDetails.givenAddress.AddressLine1}, {this.props.registerDetails.givenAddress.city}, {this.props.registerDetails.givenAddress.state}, {this.props.registerDetails.givenAddress.zip}</span>
                        </div>
                       
                        <div className="col-md-12 p-0" style={{ backgroundColor: '#ffffff' }}>

                        <div className="row m-0 pt-1 col-md-12 p-0" style={{ backgroundColor: '#f7f7f7' }}>
                        <Carousel
                            containerClass="carousel-container"
                            responsive={this.state.carouselDetails}
                        >
                            {this.props.registerDetails.givenAddress.allServiceId.map((item, key) => {
                                return (
                                    <div className={item.status ? "tabHeader activeTabHeader" : "tabHeader"} onClick={() => { this.tabClicked(item.serviceId) }} style={{ color: '#33495F' }}>{item.serviceName}</div>
                                )
                            })
                            }
                        </Carousel>
                        </div>
                        {this.state.allServiceDetailsArray.map((item, key) => {
                            if (item.serviceId === this.state.tab) {
                                return (
                                    <div className="pb-2">
                                    {this.populateAllServiceDetails(item.basePlan,item.serviceId)}
                                    {this.populateExistingDevicesComponent(item.devices)}
                                    <div className="col-md-12">
                                        <div className="col-md-12 p-0" style={{ fontSize: 14, fontWeight: 600 }}>Add-on(s)</div>
                                        {this.populateExistingAddonsComponent(item.addons, item)}
                                        {this.populateAddonDetailsComponent(item, item.addons)}
                                    </div>
                                    </div>
                                )
                            }
                        })
                        }
                        </div>
  
                      
                    </div>
                    <div className="col-md-4 pb-4 d-none d-sm-block">
                        <div className="">
                            {   this.state.addSubscriptionType === "addAddon" ||  this.state.addSubscriptionType === "addFnFAddon"
                                ?
                                <AddonCartComponent currentServiceDetails={{serviceCharge:this.state.allCurrentActiveServiceCharge}}/>
                                : null
                            }
                            {   this.state.addSubscriptionType === "changePlan" 
                                ?
                                <ServiceCartComponent currentServiceDetails={{serviceCharge:this.state.allCurrentActiveServiceCharge}}/>
                                : null
                            }
                        </div>
                    </div>

                </div>
                </div>
                <div className="d-block d-md-none bottomCartPartForMobile" style={{bottom:0}}>
                    <div className="d-flex flex-column">
                        <div className="d-flex justify-content-center pt-2"><img src={PathIcon} alt="" onClick={() => { this.arrowButtonClicked(true) }}/></div>
                        <div className="d-flex align-items-center justify-content-between px-3 pb-1">
                            <div className="amountContainer">
                                    <div>{this.props.locales.amountPaidTxtInAddonSummary}</div>
                                    <div style={{fontSize: 28}}>{Constants.dollarSign}{GeneralUtils.formatNumberToStandardForm(this.state.totalMonthlyCharges)}</div>
                            </div>
                            <div>
                            <Button className="nextButton" onClick={() => { this.closeButtonButtonClicked() }}>
                                {this.props.locales.doneBtnTxtInAddonSummary}
                            </Button>
                            </div>
                        </div>
                    </div>
                </div>
                </div>

                : 
                    <div className="col-md-4 p-0 pb-4" style={{marginTop: '110px'}}>
                    <div className="">
                        {   this.state.addSubscriptionType === "addAddon" ||  this.state.addSubscriptionType === "addFnFAddon"
                            ?
                            <AddonCartComponent currentServiceDetails={{serviceCharge:this.state.allCurrentActiveServiceCharge}}/>
                            : null
                        }
                        {   this.state.addSubscriptionType === "changePlan" 
                            ?
                            <ServiceCartComponent currentServiceDetails={{serviceCharge:this.state.allCurrentActiveServiceCharge}}/>
                            : null
                        }
                    </div>
                <div className="d-block d-md-none bottomCartPartForMobile" style={{top:0}}>
                    <div className="d-flex flex-column">
                        <div className="d-flex align-items-center justify-content-between px-3 pt-1">
                            <div className="amountContainer">
                                    <div>{this.props.locales.amountPaidTxtInAddonSummary}</div>
                                    <div style={{fontSize: 28}}>{Constants.dollarSign}{GeneralUtils.formatNumberToStandardForm(this.state.totalMonthlyCharges)}</div>
                            </div>
                            <div>
                            <Button className="nextButton"  onClick={() => { this.closeButtonButtonClicked() }}>
                                {this.props.locales.doneBtnTxtInAddonSummary}
                            </Button>
                            </div>
                        </div>
                        <div className="d-flex justify-content-center pb-2"><img className="rotate180" src={PathIcon} alt="" onClick={() => { this.arrowButtonClicked(false) }} /></div>
                    </div>
                 </div>
        
                </div>

                }

            
                <SliderModal
                    isVisible={this.state.isTermsAndConditionsModalVisible}
                    leftPartFlexValue={2}
                    rightPartFlexValue={1}
                    uniqueModalReferenceId="termsAndConditionsModal"
                    mainHeading="Disclaimer"
                    submitButtonText= "Ok"
                    isResetButtonVisible={false}
                    isCancelButtonVisible={false}
                    isSubmitButtonVisible={true}
                    callback={this.termsAndConditionsModalHandler}
                >
               
                    <div className="col-md-12 px-4 " style={{fontSize:12}}>
                        {this.props.registerDetails.services.disclaimer}
                    </div>
                </SliderModal>
                <div className="col-md-12 changePlanBottomDiv d-flex justify-content-end align-items-center">
                <div className="pr-3">
    
                </div>
                    <Button className=" changePlanBackButton" onClick={() => { window.print() }}>
                        {this.props.locales.printBtnTxtInAddonSummary}
                    </Button>
                    <Button className="changePlanNextButton" onClick={() => { this.closeButtonButtonClicked() }}>
                        {this.props.locales.doneBtnTxtInAddonSummary}
                    </Button>
                </div>
            </div>
        );
    }

}


const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        registerDetails: state.registerDetails,
        planDetails: state.planDetails,
        currentPage: state.currentPage,
        cache: state.cache
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setPlanDetails: function (key, payload) {
            dispatch(setPlanDetails(key, payload));
        },
        setCurrentPage: function (key, payload) {
            dispatch(setCurrentPage(key, payload));
        },
    }
}

const AddonsSummaryComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(AddonsSummaryComponent)


export default AddonsSummaryComponentContainer;

